import {Divider} from '@mui/material';
import type {Router} from '@toolpad/core/AppProvider';
import React from 'react';
import {OrganizationLicenseDetailsActionsBar} from './components/OrganizationLicenseDetailsActionsBar';

import {OrganizationLicenseDetailsHeader} from './components/OrganizationLicenseDetailsHeader';
import {OrganizationLicenseDetailsTable} from './components/OrganizationLicenseDetailsTable';
import {useOrganizationDetailsPageState} from './state/organization-details-page-state';

type Props = {
  router: Router
  organizationId: string;
};

export const OrganizationDetailsPage = ({router, organizationId}: Props) => {
  const state = useOrganizationDetailsPageState(organizationId)

  return state.licenseDetails && state.organizationDetails && <>
    <OrganizationLicenseDetailsHeader
      navigateToUsers={() => router.navigate(`/organization-users/${organizationId}`)}
      organizationData={state.organizationDetails}
      licenseDetails={state.licenseDetails}
      grantLog={state.grantLog}
      translate={state.translate}
      translateLocal={state.translateLocal}
    />
    <Divider sx={{ my: 2 }} />
    <OrganizationLicenseDetailsActionsBar
      createLicensePlan={state.createLicensePlan}
      recalculateLicense={state.recalculateLicense}
      updateDiscount={state.updateDiscount}
      currentDiscount={state.licenseDetails.discount}
      isCreateLicensePlanDrawerOpen={state.createOrganizationLicensePlanDrawerOpen}
      setCreateLicensePlanDrawerOpen={state.setCreateOrganizationLicensePlanDrawerOpen}
      isSaveDisabled={state.isSaveDisabled}
      massiveAction={state.massiveAction}
      setMassiveAction={state.setMassiveAction}
      onConfirmSave={state.updateFeatures}
      translateLocal={state.translateLocal}
      translate={state.translate}
    />
    <OrganizationLicenseDetailsTable
      isFeatureEnabledForPlanCreation={state.isFeatureEnabledForPlanCreation}
      isFeatureTemplateSelected={state.isFeatureTemplateSelected}
      onFeatureTemplateSelectionChanged={state.onFeatureTemplateSelectionChanged}
      massiveAction={state.massiveAction}
      featureStatusChanged={state.featureStatusChanged}
      featureSubscriptionTypeChanged={state.featureSubscriptionTypeChanged}
      featureTrialDateChanged={state.featureTrialDateChanged}
      mainTableRows={state.mainTableRows}
      getChildRows={state.getChildRows}
      getFeatureDetails={state.getFeatureDetails}
      translate={state.translate}
      translateLocal={state.translateLocal}
    />
  </>
}
